// Services

// unit

// unit.pad                добавление нулей (возможно в генерации айдишников используется)
// unit.merge              объединение ячеек
// unit.split              разделение ячеек
// unit.markedOffice       отметка как офис
// unit.countOfValue       считает кол-во квартир для статистики
// unit.totalRooms         подсчет для статистики
// unit.cancelDeal         отмена сделки - используется в контроллере попапа
// unit.getClassName       unitPopup.changeStatus, в отмене сделки и т.д.
// unit.initJqueryFunc
// unit.setNowDate         текущая дата в datepicker - возможно уже не используется
// unit.multiFilter        используется в estSelectTag
// unit.watchInputFilter   используется в estTagFilter директиве, которая юзает magic-suggest + вызов последнего метода неправильный

angular
  .module('estoffice.legacy')
  .service(
    'unit',
    function (
      $rootScope,
      $q,
      api,
      request,
      $mdDialog,
      $templateCache,
      $cookieStore,
    ) {
      var unit = this;

      unit.activeHouse = '';
      unit.columnChange = false;
      unit.contactCustomFields = [];
      // перенес снизу - начало
      unit.featureLabel = [];
      unit.customLabel = [];
      unit.images = {};
      unit.imagesFloor = {};
      unit.oldStatus = 1;
      unit.currentStatus = 1;
      unit.actionType = '';
      unit.contactCard = {};
      unit.leadId;
      unit.dataObj = [];
      unit.filter = {};
      unit.countRooms = [];
      // перенес снизу - конец
      unit.count = {
        rooms: {},
        offices: 0,
        total: 0,
      };
      unit.oldValRooms = 0;
      // unit.countRooms = {}; убрал, потому что эта переменная перезаписывалась той, что выше

      unit.pad = function (str, max) {
        str = str.toString();
        return str.length < max ? unit.pad('0' + str, max) : str;
      };

      unit.merge = function (unitId, joinId) {
        var deferred = $q.defer();
        var url = api.basic.merge.replace('{{unitId}}', unitId);
        var data = {
          join: joinId,
          token: $rootScope.token,
        };
        request.post(url, data, function (response) {
          deferred.resolve(response.data);
        });
        return deferred.promise;
      };
      unit.split = function (unitId) {
        var deferred = $q.defer();
        var url = api.basic.splitted.replace('{{unitId}}', unitId);
        request.post(url, { unit_id: unitId }, function (response) {
          deferred.resolve(response.data);
        });
        return deferred.promise;
      };
      unit.markedOffice = function (unitId, type) {
        var deferred = $q.defer();
        var url = api.basic.office.replace('{{unitId}}', unitId);
        var data = {
          type: type,
          token: $rootScope.token,
        };
        request.post(url, data, function (response) {
          deferred.resolve(response.data);
        });
        return deferred.promise;
      };

      //    unit.count = {
      //      rooms: {},
      //      offices: 0,
      //      total: 0
      //    };
      //    unit.oldValRooms = 0;   перенес вверх

      unit.countOfValue = function (mainObj) {
        var countValue = function (obj, value) {
          var count = 0;
          $.each(obj, function (i, el) {
            if (el == value) count++;
          });
          return count;
        };

        var contains = function (obj, v) {
          var test = false;
          $.each(obj, function (i, el) {
            if (el === v) test = true;
          });
          return test;
        };

        var unique = function (obj) {
          var arr = [];
          $.each(obj, function (i, el) {
            if (!contains(arr, el)) {
              arr.push(el);
            }
          });
          return arr;
        };

        var uniq = unique(mainObj);
        uniq = uniq.sort();
        var ret = [];
        uniq.forEach(function (el) {
          var t = countValue(mainObj, el);
          ret.push({ type: el, count: t });
        });
        return ret;
      };

      // unit.countRooms = {}; перенес вверх и как оказалось внизу эта переменная перезаписывалась массивом
      unit.totalRooms = function () {
        var total = 0;
        angular.forEach(unit.countRooms, function (el, i) {
          if (el.type != 0) {
            total += el.count;
          }
        });
        return total;
      };

      unit.getClassName = function (status) {
        var status = '' + status;
        var className = '';
        switch (status) {
          case '1':
            className = '-type_notinstock';
            break;
          case '2':
            className = '-type_available';
            break;
          case '3':
            className = '-type_reservation';
            break;
          case '4':
            className = '-type_sold';
            break;
        }
        return className;
      };

      unit.initJqueryFunc = function () {
        initScrollbar();
        initDatePicker();
        initFormStyler();
        initLightbox();
        popupOpenCloseWindow();
      };

      unit.multiFilter = function (arr, num) {
        var countIndex = arr.indexOf(num);
        if (countIndex == -1) {
          arr.push(num);
        } else {
          arr.splice(countIndex, 1);
        }
        return arr;
      };

      unit.setNowDate = function (className) {
        var now = new Date();
        $('.' + className).datepicker('setDate', now);
        $('.' + className).trigger('input');
      };
    },
  );
